
import type { ReactElement, FC } from "react"
import { Grid, Drawer, type SxProps, Divider, Box } from "@mui/material"

interface DrawerMenuProps {
    open: boolean, 
    sx?: SxProps
    children?:ReactElement,
    footer?:ReactElement
    onClose?:((event: {}, reason: "backdropClick" | "escapeKeyDown") => void)
}

export const DrawerMenu: FC<DrawerMenuProps> = ({
    open, 
    sx,
    children,
    footer,
    onClose
}) => {
    
    return (
        <Drawer
            anchor='left'
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        ...sx,
                        width: 360,
                        top: 64,
                        borderRadius: 0
                    }
                }
            }}
        >
            <Grid container sx={{height:'100%'}} flexDirection='column'>
                <Grid flex={1}>
                    {children}
                </Grid>
                <Grid>
                    { footer && (
                        <Box>
                            <Divider/>
                            {footer}
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Drawer>
    )

}